import axios from "axios";
import { STORAGE_KEYS } from "./constants";

const handleError = (error) => {
  let err = { status: 500, message: "Something went wrong, please try again" };
  if (error.response) {
    err = {
      status: error.response.status,
      message: error.response.data?.message || "Something went wrong, please try again",
    };
    if (err.status === 401) {
      localStorage.removeItem(STORAGE_KEYS.token);
      localStorage.removeItem(STORAGE_KEYS.user);
      localStorage.removeItem(STORAGE_KEYS.store);
      window.location.href = "/login";
    } else if (err.status === 422) {
      err.errors = error.response.data?.errors;
    }
  }
  return Promise.reject(err);
};

// Every request gets a hard deadline — mirrors denzo-waiter's utils/http.js:
// without one, a hung request (dropped connection, flaky mobile network — the
// exact conditions a driver out on the road hits) never rejects on its own,
// leaving an `await apiClient...` call stuck forever with no way for the UI
// to recover.
const REQUEST_TIMEOUT_MS = 15000;

// Bearer-authenticated client for every request after login.
export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { Accept: "application/json" },
  timeout: REQUEST_TIMEOUT_MS,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_KEYS.token);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use((res) => res, handleError);

// No-auth client, for the login call itself.
export const apiAuth = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { Accept: "application/json" },
  timeout: REQUEST_TIMEOUT_MS,
});

apiAuth.interceptors.response.use((res) => res, handleError);
